import axios from "../../libs/httpClient";
import { host } from "../../libs/webRTC";

export function replacer(key, value) {
    if (value instanceof Map) {
        return {
            dataType: 'Map',
            value: Array.from(value.entries()),
        };
    }
    return value;
}

export async function getCurrentUser() {
    try {
        const response = await axios.get(`${host}/userAuthInfo/current`);
        if (response.data) {
            return {
                id: response.data._id,
                name: response.data.name,
                login: response.data.login,
                group: response.data.group,
                isAdmin: response.data.access === 'Admin',
                routes: response.data.routes
            };
        }
        return null;
    } catch (error) {
        if (error.response && error.response.status === 401) return null;
        console.warn('Failed to get current user:', error.message);
        throw error;
    }
}

export async function login(params) {
    const response = await axios.post(`${host}/userAuthInfo`, { map: JSON.stringify(params, replacer) });
    return response.data;
}

export async function logout() {
    await axios.post(`${host}/userAuthInfo/logout`);
    return { success: true };
}
